import { useMemo } from 'react'
import { Button, Image } from 'react-bootstrap'
import { SERVER_DATA } from '../../core/constants/app'
import { downloadZipPhotos, getPhotosVehicle } from '../../utils/invoice'
import useAppContext from '../app'

const PhotosMobile = ({ onShowPhoto, vehicle = {} }) => {
  const { setIsLoading } = useAppContext()
  const photos = useMemo(() => {
		return getPhotosVehicle(vehicle)
	}, [vehicle])

  if (photos.length <= 0) return null

  return (
    <>
      <div className='mt-3'>
        <span className='d-block fs-small fw-600 mb-2'>Photos</span>
        <div className='d-grid grid-auto-columns grid-template-areas-5 grid-gap-2'>
          {photos.map((photo, index) => {
            return (
              <Image
                key={photo._id}
                src={`${SERVER_DATA}/${photo.url}`}
                className='w-100'
                onClick={() => onShowPhoto(vehicle, index)}
              />
            )
          })}
        </div>

        <div className='text-center pt-3'>
          <Button
            variant='default'
            className='fs-sub text-primary fw-bold text-uppercase p-0'
            onClick={() => {
              setIsLoading(true)
              downloadZipPhotos(vehicle, () => {
                setIsLoading(false)
              })
            }}
          >
            Download All Photos
          </Button>
        </div>
      </div>
    </>
  )
}

export default PhotosMobile
